import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMatomoComponent } from './simple-icons-matomo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMatomoComponent ],
    exports:      [ SimpleIconsMatomoComponent ],
    bootstrap:    []
})
export class SimpleIconsMatomoModule {}
